import { render, staticRenderFns } from "./GoalLinkDetails.vue?vue&type=template&id=b93314a2"
import script from "./GoalLinkDetails.vue?vue&type=script&lang=js"
export * from "./GoalLinkDetails.vue?vue&type=script&lang=js"
import style0 from "./GoalLinkDetails.vue?vue&type=style&index=0&id=b93314a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports